import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss'
  // Default change detection on purpose: the routed pages (reports, create licence) update
  // plain fields from HTTP callbacks, and an OnPush shell would leave them unchecked.
})
export class MainLayout {}
